import type { IconName } from '@/shared/components/ui/Icon';
import type { MessageKey } from '@/shared/i18n/messages';

export interface ClientRoute {
  readonly id: string;
  /** Path under ClientShell: procalendar.app/<path>. */
  readonly path: string;
  readonly index?: boolean;
  readonly icon: IconName;
  readonly navKey: MessageKey;
  readonly titleKey: MessageKey;
  readonly descriptionKey: MessageKey;
}

/**
 * The end client's navigation on procalendar.app. Deliberately short — these
 * are people who never chose this software.
 */
export const CLIENT_ROUTES: readonly ClientRoute[] = [
  {
    id: 'book',
    path: 'book',
    index: true,
    icon: 'calendar',
    navKey: 'client.nav.book',
    titleKey: 'client.book.title',
    descriptionKey: 'client.book.description',
  },
  {
    id: 'bookings',
    path: 'me/bookings',
    icon: 'notes',
    navKey: 'client.nav.bookings',
    titleKey: 'client.bookings.title',
    descriptionKey: 'client.bookings.description',
  },
  {
    id: 'account',
    path: 'me/account',
    icon: 'user',
    navKey: 'client.nav.account',
    titleKey: 'client.account.title',
    descriptionKey: 'client.account.description',
  },
  {
    id: 'settings',
    path: 'settings',
    icon: 'settings',
    navKey: 'client.nav.settings',
    titleKey: 'settings.title',
    descriptionKey: 'settings.subtitle',
  },
];
